import { render } from "./item-transaction.vue?vue&type=template&id=bed46f0e"
import script from "./item-transaction.js?vue&type=script&lang=js&external"
export * from "./item-transaction.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__